import React, { useState } from "react";

import {
  IonContent,
  IonGrid,
  IonModal,
  IonHeader,
  IonAlert,
  IonTitle,
  IonToolbar,
  IonRow,
  IonIcon,
  IonCol,
  IonButton,
} from "@ionic/react";
import { utilService } from "../../../services/utilService";
import { DoctorInfoReq } from "./Sms.model";
import { smsService } from "./Sms.service";
import SendSms from "./Components/SendSms/SendSms";
import { callOutline } from "ionicons/icons";
import classNames from "classnames/bind";

import "./sms.scss";

interface smsParams {
  selectedDoctorGuid: string;
  isAssignedNumber?: boolean;
  callerComponent?: string;
  pid?: string;
  unitId?: any;
}
const Sms: React.FC<smsParams> = (props) => {
  var [doctorInfoData, setDoctorInfoData]: any = useState([]);
  const [isShowSmsModal, setIsShowSmsModal] = useState(false);
  const [isShowSendSmsModal, setIsShowSendSmsModal] = useState(false);
  const [isPrimaryNumber, setIsPrimaryNumber] = useState(false);
  const [isShowAlert, setIsShowAlert] = useState(false);

  async function fetchDoctorInfo(params: DoctorInfoReq) {
    const respDoctorListResult: any = await smsService.getDoctorInformation(
      params
    );
    if (respDoctorListResult.isSuccess) {
      setDoctorInfoData(respDoctorListResult.result);
      if (respDoctorListResult.result) {
        checkSecondaryNumberExists(respDoctorListResult.result.userData);
      }
    } else {
      console.log("error");
      smsService.handleErrorResponse();
    }
  }

  async function fetchAssignedContactInfo(params: DoctorInfoReq) {
    const respDoctorListResult: any =
      await smsService.getAssignedContactInformation(params);
    if (respDoctorListResult.isSuccess) {
      setDoctorInfoData(respDoctorListResult.result);
      if (respDoctorListResult.result) {
        checkSecondaryNumberExists(respDoctorListResult.result.userData);
      }
    } else {
      console.log("error");
      smsService.handleErrorResponse();
    }
  }

  const checkSecondaryNumberExists = (userData: any) => {
    if (userData.alternateNumber === "" || userData.assignNumber) {
      setIsShowAlert(true);
    } else {
      setIsShowSmsModal(true);
    }
  };

  const paramsDoctorInfo = {
    guid: props.selectedDoctorGuid,
    reg_code: utilService.getNetwork(),
  };

  return (
    <div className="sms-container" onClick={(e) => e.stopPropagation()}>
      <div
        className={classNames({
          "input-icon": true,
          "icon-message": true,
        })}
        onClick={() => {
          props.isAssignedNumber
            ? fetchAssignedContactInfo(paramsDoctorInfo)
            : fetchDoctorInfo(paramsDoctorInfo);
        }}
      ></div>
      <IonAlert
        isOpen={isShowAlert}
        onDidDismiss={() => setIsShowAlert(false)}
        cssClass="sms-alert"
        header="Confirmation Message"
        message="Are you sure you want to message?"
        buttons={[
          {
            text: "NO",
            role: "cancel",
            cssClass: "secondary",
          },
          {
            text: "OK",
            handler: () => {
              setIsPrimaryNumber(true);
              setIsShowSendSmsModal(true);
            },
          },
        ]}
      />
      <IonModal
        isOpen={isShowSmsModal}
        backdropDismiss={false}
        className="sms-modal"
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Confirmation Message</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent className="content-container">
          <IonRow className="confirm-label">
            <IonCol> Are you sure you want to message?</IonCol>
          </IonRow>
          <IonGrid className="grid-container">
            <IonRow className="message-with-label">
              <IonCol>Message With</IonCol>
            </IonRow>
            <IonRow className="primary-button-row">
              <IonCol>
                {/* <IonButton
                  className="submit-btn button primary-btn  primary-button"
                  shape="round"
                  onClick={() => {
                    setIsShowSmsModal(false);
                    setIsShowSendSmsModal(true);
                    setIsPrimaryNumber(true);
                  }}
                >
                  <IonIcon slot="start" icon={callOutline} />
                  Primary Number
                </IonButton> */}
              </IonCol>
            </IonRow>
            <IonRow className="secondary-button-row">
              <IonCol>
                {/* <IonButton
                  className="submit-btn button primary-btn  secondary-button"
                  shape="round"
                  onClick={() => {
                    setIsShowSmsModal(false);
                    setIsShowSendSmsModal(true);
                    setIsPrimaryNumber(false);
                  }}
                >
                  <IonIcon slot="start" icon={callOutline} />
                  Secondary Number
                </IonButton> */}
              </IonCol>
            </IonRow>
            <IonRow className="no-label">
              <IonCol>
                <div
                  className="confirm-btn clickable no-button"
                  onClick={() => {
                    setIsShowSmsModal(false);
                  }}
                >
                  NO
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
      </IonModal>
      {doctorInfoData.userData && (
        <SendSms
          doctorInfoData={doctorInfoData}
          isShowSendSmsModal={isShowSendSmsModal}
          isPrimaryNumber={isPrimaryNumber}
          isAssignedNumber={props.isAssignedNumber}
          pid={props.pid}
          unitId={props.unitId}
          onOk={() => {
            setIsShowSendSmsModal(false);
          }}
          onCancel={() => {
            setIsShowSendSmsModal(false);
          }}
        ></SendSms>
      )}
    </div>
  );
};

export default Sms;
